import Alert from "@/components/ui/alert";

export default function AppStopped() {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <div className="w-fit mx-auto mb-8">
        <Alert
          className="w-fit"
          title="The job was stopped"
          description="The job was stopped unexpectedly."
        />
      </div>
    </div>
  );
}
